export const standardCheckBoxesCode =
`
  <CheckBox table />
`;

export const roundCheckBoxesCode =
`
  <CheckBox rounded />
`;

export const radioButtonsCode =
`
  <RadioButton label="Some option" />
`;

export const singleSelectorCode =
`
  <Selector text="Single Line" />
`;

export const multiSelectorCode =
`
  <Selector multi />
`;

export const specialCaseSelectorCode =
`
  <Selector multi bgImage="Visa" />
`;

export const dropdownsCode =
`
  <Dropdown label="Label" opts={['option1', 'option2', 'option3']} />
`;

export const dropdownsSimplifiedCode =
`
  <Dropdown simplified label="Label" opts={['option1', 'option2', 'option3']} />
`;

export const standardInputTextCode =
`
  <FormField>
    <InputField
      label="label"
      icon={icon:'link-arrow-right-17', type: 'other'}
      customClasses="withIcon"
      note="Helper note"
      prefixText="Rs."
      suffixText="%"
    />
  </FormField>
`;

export const passwordInputCode =
`
  <FormField>
    <PasswordInput
      label="Password"
      placeholder="Determine Password"
      customClasses="withIcon"
      validations={['required', 'password']}
    />
  </FormField>
`;

export const phoneNumberCode =
`
  <FormField>
    <Row>
      <PrefixInput placeholder="351" locked={locked} />
      <InputField label="Phone Number" type="number" />
    </Row>
  </FormField>
`;

export const cardNumberCode =
`
  <FormField>
    <CCInput label="Credit Card" validations={['credit-card']} />
  </FormField>
  <FormField>
    <CCDateInput label="Credit Card Date" />
  </FormField>
  <FormField>
    <CVVInput validations={['required', 'cvv']} label="Credit Card CCV" />
  </FormField>
`;

export const searchFieldCode =
`
  <FormField>
    <InputField
      label="label"
      icon={icon: 'search', type: '40'}}
      customClasses="withIcon" />
  </FormField>
`;

export const searchFieldPrefixCode =
`
  <FormField>
    <InputField
      label="label"
      placeholder="Input Text"
      prefixText="Lorem"
      icon={icon: 'search', type: '40' }}
      customClasses="withIcon" />
  </FormField>
`;

export const searchWithWordFinderCode =
`
  <FormField size="normal">
    <InputField
      label="label"
      placeholder="Input Text"
      autoComplete={autoCompleteItems} />
  </FormField>
`;

export const searchWithClearFieldCode =
`
  <FormField size={size} darkBg={darkBg}>
    <InputField
      placeholder="Input Text"
      clearable
      autoComplete={autoCompleteItems}
      actionIcon= {icon: 'clear-fill-16', type: 'other'}}
      />
  </FormField>
`;



// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/constants/inputsCode.js